/* eslint-disable camelcase */
export const handleSubmitShadowRouting = ({ value, queryManager, did }) => {
  const initialValue = queryManager.get.query.data?.number || '';
  if (!value) {
    return;
  }
  if (!initialValue) {
    queryManager.add.query({
      did,
      number: value,
    });
    return;
  }
  if (initialValue !== value) {
    queryManager.update.query({
      did,
      id: queryManager.get.query.data?.id,
      number: value,
    });
  }
};
export const handleSubmitUpdateRouting = ({
  value,
  initialValue,
  queryManager,
  did,
}) => {
  if (Object.keys(value).length === 0) {
    return;
  }
  if (initialValue === value) {
    return;
  }
  queryManager.update.query({
    did,
    data: Object.entries(value).map(
      ([id, { originatingNetwork: nature_id, routingNumber: number_out }]) => ({
        id,
        nature: { id: nature_id },
        number_out,
      })
    ),
  });
};
export const handleSubmitAddRouting = ({ value, queryManager, did }) => {
  if (Object.keys(value).length === 0) {
    return;
  }
  queryManager.add.query({
    did,
    data: Object.values(value).map(
      ({ originatingNetwork: id, routingNumber: number_out }) => ({
        nature: { id },
        number_out,
      })
    ),
  });
};

export const handleSubmitTrunk = ({
  value,
  initialValue,
  queryManager,
  did,
}) => {
  if (value === initialValue) {
    return;
  }
  queryManager({
    did,
    data: { customer_trunk: { id: value } },
  });
};
